import { render, staticRenderFns } from "./courseTopic.vue?vue&type=template&id=11bcff9e"
import script from "./courseTopic.vue?vue&type=script&lang=js"
export * from "./courseTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports